export const PAID_REVENUE_HT_LABEL = 'Réglé HT sur factures émises';
export const PAID_REVENUE_HT_SOURCE = 'Qonto';

export function paidRevenueHtScope(year: number): string {
  return `Cohorte ${year}, payé à date · ${PAID_REVENUE_HT_SOURCE}`;
}
